// Construire un formateur `Intl` coûte bien plus que s'en servir, et une
// grille formate des milliers de valeurs à chaque rendu : on garde chaque
// formateur, par locale et options (peu de combinaisons en pratique).

const formats = new Map<string, Intl.DateTimeFormat | Intl.NumberFormat | Intl.RelativeTimeFormat>();

function cached<T extends Intl.DateTimeFormat | Intl.NumberFormat | Intl.RelativeTimeFormat>(
  kind: string,
  locale: string,
  options: object,
  make: () => T,
): T {
  const key = `${kind}|${locale}|${JSON.stringify(options)}`;
  let format = formats.get(key) as T | undefined;
  if (!format) {
    format = make();
    formats.set(key, format);
  }
  return format;
}

export function dateTimeFormat(locale: string, options: Intl.DateTimeFormatOptions = {}) {
  return cached("date", locale, options, () => new Intl.DateTimeFormat(locale, options));
}

export function numberFormat(locale: string, options: Intl.NumberFormatOptions = {}) {
  return cached("number", locale, options, () => new Intl.NumberFormat(locale, options));
}

export function relativeTimeFormat(locale: string, options: Intl.RelativeTimeFormatOptions = {}) {
  return cached("relative", locale, options, () => new Intl.RelativeTimeFormat(locale, options));
}
